<div *ngIf="pager.hasMore" class="flex flex-col items-center gap-2 border-t border-gray-100 pt-4 mt-4">
  <p *ngIf="total && total > shown" class="m-0 text-sm text-text-secondary">
    Showing {{ shown | number }} of {{ total | number }} reviews
  </p>
  <p *ngIf="pager.loadMoreFailed && !pager.loadingMore" role="alert" class="m-0 text-sm text-red-700">
    Couldn't load more reviews. Check your connection and try again.
  </p>
  <button
    type="button"
    (click)="more()"
    [disabled]="pager.loadingMore"
    [attr.aria-busy]="pager.loadingMore"
    class="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-lg border-2 border-primary/20 px-4 text-sm font-medium text-primary transition-colors hover:border-primary/40 hover:bg-primary/5 disabled:cursor-wait disabled:opacity-70 sm:w-auto"
  >
    <mat-spinner *ngIf="pager.loadingMore; else icon" diameter="18" aria-hidden="true"></mat-spinner>
    <ng-template #icon>
      <mat-icon class="!size-5 !text-xl !leading-5" aria-hidden="true">{{ pager.loadMoreFailed ? 'refresh' : 'expand_more' }}</mat-icon>
    </ng-template>
    {{ pager.loadingMore ? 'Loading more reviews...' : pager.loadMoreFailed ? 'Try again' : 'Show more reviews' }}
  </button>
</div>
